import { useState } from 'react';

import { Button, Select, Text } from '@nvision/ui';

import { Card } from '@/components/card';
import { PostalSearchModal } from '@/modules/entities';

import { useTariffsControls } from '../../../hooks';

import styles from './tariffs-controls.module.css';

export const TariffsControls: React.FC = () => {
  const {
    changeSort,
    deleteTariffs,
    classRate,
    changeEffectiveDates,
    exportTariffs,
    addTariff,
    isDeleteDisabled,
    isClassRateDisabled,
    isChangeDatesDisabled,
    isExportDisabled,
    selectedSortOption,
    sortOptions,
  } = useTariffsControls();

  // tmp
  const [isPostalOpened, setPostalOpened] = useState(false);

  const onSelectionChange = <T,>(values: T[]) => {
    console.log(values);
  };

  return (
    <Card>
      <Card.Header>
        <Text size="sm" weight="semibold">
          Tariff Results
        </Text>
      </Card.Header>
      <Card.Main>
        <div className={styles.controls}>
          <div className={styles.leftSection}>
            <Select
              options={sortOptions}
              value={selectedSortOption}
              placeholder="Select"
              onSelectionChange={changeSort}
              className={styles.sortSelect}
              size="sm"
            />
          </div>

          <div className={styles.rightSection}>
            <Button size="sm" iconLeft="trash" onClick={deleteTariffs} isDisabled={isDeleteDisabled} ghost>
              Delete
            </Button>
            <Button size="sm" iconLeft="check-circle" onClick={classRate} isDisabled={isClassRateDisabled} ghost>
              Class Rate Tariff
            </Button>
            <Button
              size="sm"
              iconLeft="calendar"
              onClick={changeEffectiveDates}
              isDisabled={isChangeDatesDisabled}
              ghost
            >
              Change Effective Dates
            </Button>
            <Button size="sm" iconLeft="download" onClick={exportTariffs} isDisabled={isExportDisabled} ghost>
              Export
            </Button>
            <Button size="sm" iconLeft="plus-circle" onClick={addTariff} primary>
              Add Tariff
            </Button>
            <Button size="sm" onClick={() => setPostalOpened(true)} primary>
              Postal Search
            </Button>
          </div>
        </div>
      </Card.Main>
      <PostalSearchModal isOpen={isPostalOpened} setIsOpen={setPostalOpened} onSelectionChange={onSelectionChange} />
    </Card>
  );
};
